import { render } from "./ChoiceCourses.vue?vue&type=template&id=5f0fe982&scoped=true"
import script from "./ChoiceCourses.vue?vue&type=script&lang=js"
export * from "./ChoiceCourses.vue?vue&type=script&lang=js"

import "./ChoiceCourses.vue?vue&type=style&index=0&id=5f0fe982&scoped=true&lang=css"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f0fe982"]])

export default __exports__